import React from 'react'
import { ClickAwayListener, Popper } from '@mui/material'
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'

import useStyles from './styles'

interface PopperEmojiPickerProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  handleEmojiSelect: (emoji: any) => void
}

const PopperEmojiPicker: React.FC<PopperEmojiPickerProps> = ({
  setOpen,
  handleEmojiSelect
}) => {
  const ref = React.useRef(null)
  const classes = useStyles()

  const handlePickerSelect = React.useCallback(
    emoji => {
      handleEmojiSelect(emoji)
      setOpen(false)
    },
    [handleEmojiSelect, setOpen]
  )

  const handleClose = React.useCallback(() => {
    setOpen(false)
  }, [setOpen])

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div className={classes.emojiIconClickAwayContainer} ref={ref}>
        <Popper anchorEl={ref.current} open style={{ zIndex: 9999 }}>
          <Picker
            data={data}
            previewPosition={'none'}
            onEmojiSelect={handlePickerSelect}
            autoFocus
          />
        </Popper>
      </div>
    </ClickAwayListener>
  )
}

export default PopperEmojiPicker
